import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
    saved: null,
    isError: false,
    isSuccess: false,
    isLoading: false,
};

export const SaveObjectAction = createAsyncThunk(
    "save/object",
    async (data) => {
        return data;
    }
);

const SaveSlice = createSlice({
    name: "save",
    initialState,
    reducers: {
        resetSave: (state) => {
            state.saved = null;
            state.isError = false;
            state.isSuccess = false;
            state.isLoading = false;
        },
        saveObj: (state, action) => {
            state.saved = action.payload;
        },
    },

    extraReducers: {
        [SaveObjectAction.fulfilled]: (state, action) => {
            state.saved = action.payload;
        },
    },
});

export const { resetSave, saveObj } = SaveSlice.actions;
export default SaveSlice.reducer;
